import { render, staticRenderFns } from "./st-article.vue?vue&type=template&id=fc533338&"
import script from "./st-article.vue?vue&type=script&lang=js&"
export * from "./st-article.vue?vue&type=script&lang=js&"
import style0 from "./st-article.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports